<template>
	<div>
		<app-table
			class="mt-3"
			name="roles-access-subresources"
			:columns="columns"
			:current-page="currentPage"
			:rows="rows"
			:check-all="checkAll"
			:last-page="lastPage"
			selectable
			@on-selected-all="allIsSelected"
			@on-page="changePage"
			@on-search-event="onSearch"
			@row-is-selected="rowIsSelected"
		>
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)">{{ props.row.name }}</td>
			</template>
		</app-table>
	</div>
</template>

<script>
function allIsSelected(checked) {
	this.$emit('all-is-selected', checked);
}

function changePage(page) {
	this.$emit('change-page', page);
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

export default {
	name: 'role-access-subresource-list',
	props: {
		columns: {
			type: Array,
			required: true,
		},
		checkAll: {
			default: false,
			type: Boolean,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	methods: {
		allIsSelected,
		changePage,
		onSearch,
		rowIsSelected,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/roles/role-access-subresource-list.vue